export enum PriceCompareStatus {
  /**
   * 待发布
   */
  WAIT_PUBLISH = 0,
  /**
   * 待审核
   */
  WAIT_AUDIT = 1,
  /**
   * 审核通过
   */
  AUDIT_SUCCESS = 2,
  /**
   * 审核不通过
   */
  AUDIT_FAIL = 3,
  /**
   * 委托方已确认
   */
  ENTRUST_CONFIRMED = 4,
  /**
   * 参与方拒绝，待再次确认
   */
  WAIT_ENTRUST_CONFIRMED_AGAIN = 5,
  /**
   * 已成交
   */
  DEAL = 6,
  /**
   * 部分成交
   */
  DEAL_PART = 7,
  /**
   * 流拍
   */
  DEAL_FAIL = 8,
  /**
   * 委托方终止交易
   */
  ENTRUST_HALT = 9,
  /**
   * 终止未通过
   */
  HALT_FAIL = 10,
  /**
   * 已终止
   */
  HALT_SUCCESS = 11
}

export const PriceCompareStatusTextMap = {
  [PriceCompareStatus.WAIT_PUBLISH]: '待发布',
  [PriceCompareStatus.WAIT_AUDIT]: '待审核',
  [PriceCompareStatus.AUDIT_SUCCESS]: '审核通过',
  [PriceCompareStatus.AUDIT_FAIL]: '审核不通过',
  [PriceCompareStatus.ENTRUST_CONFIRMED]: '委托方已确认',
  [PriceCompareStatus.WAIT_ENTRUST_CONFIRMED_AGAIN]: '待委托方二次确认',
  [PriceCompareStatus.DEAL]: '已成交',
  [PriceCompareStatus.DEAL_PART]: '部分成交',
  [PriceCompareStatus.DEAL_FAIL]: '流拍',
  [PriceCompareStatus.ENTRUST_HALT]: '委托方终止交易',
  [PriceCompareStatus.HALT_FAIL]: '终止未通过',
  [PriceCompareStatus.HALT_SUCCESS]: '已终止'
}
